// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-gynecological-days .hero-contents__subtitle {
  font-weight: 400 !important;
  color: #6efff6 !important;
  -webkit-text-stroke: 1px var(--primary-color);
  paint-order: stroke fill;
}
.hero-gynecological-days .hero-contents.centered {
  align-items: stretch;
}
.hero-gynecological-days .hero-episode-card {
  border: 1px solid #4edbd2;
  box-sizing: border-box;
}
@media (min-width: 768px) {
  .hero-gynecological-days .hero-episode-card {
    width: calc(33.333% - 20px);
    flex: 0 0 auto;
  }
}
.hero-gynecological-days .hero-episode-card__container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.hero-gynecological-days .hero-episode-card__title {
  text-transform: uppercase;
}
@media (min-width: 1200px) {
  .hero-gynecological-days .hero-episode-card__title {
    font-size: var(--hero-episode-title-font-size-desktop);
  }
}
.hero-gynecological-days .hero-episode-card__live-date {
  margin-bottom: 1rem;
}
.hero-gynecological-days .hero-episode-card__live-date + .hero-episode-card__live-date {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: auto;
  margin-bottom: 0;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
  font-size: 0.85em;
  opacity: 0.85;
}
.hero-gynecological-days .hero-episode-card--live .hero-episode-card__live-date + .hero-episode-card__live-date::before {
  content: "";
  flex-shrink: 0;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ff4d4d;
  box-shadow: 0 0 0 0 rgba(255, 77, 77, 0.55);
  animation: hero-live-pulse 1.8s ease-out infinite;
}

@keyframes hero-live-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 77, 77, 0.55);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(255, 77, 77, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 77, 77, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Hero/HeroGynecologicalDays/HeroGynecologicalDays.scss"],"names":[],"mappings":"AAGI;EACI,2BAAA;EACA,yBAAA;EACA,6CAAA;EACA,wBAAA;AAFR;AAKI;EACI,oBAAA;AAHR;AAMI;EACI,yBAAA;EACA,sBAAA;AAJR;AAMQ;EAJJ;IAKQ,2BAAA;IACA,cAAA;EAHV;AACF;AAMI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAJR;AAOI;EACI,yBAAA;AALR;AAOQ;EAHJ;IAIQ,sDAAA;EAJV;AACF;AAOI;EACI,mBAAA;AALR;AAQI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,+CAAA;EACA,iBAAA;EACA,aAAA;AANR;AASI;EACI,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EACA,iDAAA;AAPR;;AAWA;EACI;IACI,2CAAA;EARN;EAWE;IACI,0CAAA;EATN;EAYE;IACI,wCAAA;EAVN;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
